// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"508":"25f5e7c6","956":"31f740fa"}[chunkId] + ".chunk.css";
};